<a [href]="href" (click)="redirect($event)" [class]="linkClass ? linkClass : ''"
   [rel]="target === '_blank' ? 'noopener' : (rel ? rel : '')" [target]="target"
   [attr.aria-label]="ariaLabel ? ariaLabel : null" class="ext-link">
  <ng-content select="[body]"></ng-content>
</a>
